import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, patch, put, del } from './agent';

const securityRoles =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'security-roles', id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      upsert: (body) => (id ? patch : post)(url, body),
      clone: (body) => post(url.concat('/clone'), body),
      history: () => get(url.concat('/history')),
      setActiveStatus: (flag = true) => put(url.concat('/is-active'), { isActive: flag }),
      setDefaultStatus: () => put(url.concat('/is-default')),
      delete: () => del(url),
    };
  };

export default securityRoles;
